module.exports = __webpack_public_path__ + "img/mynewsimg6.0e3366c9.png";